import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import React, { useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewContractModal from "./ViewContract";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { onOffArr, statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const ContractSingleAction = ({
  contractData,
  onDeleteContract,
  onPublishContract,
  permission,
  refreshList,
  ...props
}: {
  contractData: any;
  onDeleteContract: Function;
  onPublishContract: Function;
  permission: any;
  refreshList?: Function;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedContractId = encryptUrl(`${contractData.id}`);

  const contractUpdateLink = ContentRoutes.UPDATE_CONTRACT.replace(
    ":id",
    ecryptedContractId.toString()
  );

  const navigate = useNavigate();
  const publishText =
    contractData?.is_last_active_contract == onOffArr.on
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t(
    contractData?.is_last_active_contract == onOffArr.on
      ? "CONFIRM_ACTION"
      : "CONFIRM_CONTRACT_ACTION",
    {
      action:
        contractData?.is_last_active_contract == onOffArr.on
          ? t("UNPUBLISH").toLowerCase()
          : t("PUBLISH").toLowerCase(),
      entity: t("CONTRACT").toLowerCase(),
    }
  );
  const publishIcon =
    contractData?.is_last_active_contract == onOffArr.off ? (
      <BlockRoundIcon />
    ) : (
      <CheckRoundIcon />
    );

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      setOpenModalByName(eventKey);
      dispatch(setActionData(contractData));
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-contract"}>{t("VIEW")}</Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${contractUpdateLink}`);
  }

  return (
    <div>
      {permission.update && (
        <>
          <IconButton
            appearance="subtle"
            onClick={handleEditAction}
            title={t("UPDATE")}
            icon={<Edit />}
          />
        </>
      )}
      {permission.delete && (
        <>
          <IconButton
            onClick={() => {
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {permission.publish && (
        <>
          <IconButton
            onClick={() => {
              setOpenPublishModal(true);
              setPublishMessage(pMessage);
            }}
            icon={publishIcon}
            title={publishText}
            size="md"
          />
        </>
      )}
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-contract" && (
        <ViewContractModal
          status={openModalByName === "view-contract" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteContract(contractData);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("CONTRACT").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishContract(contractData);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default ContractSingleAction;
